import { render, staticRenderFns } from "./FooterIcon2.vue?vue&type=template&id=dda72fb4&scoped=true&"
var script = {}
import style0 from "./FooterIcon2.vue?vue&type=style&index=0&id=dda72fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda72fb4",
  null
  
)

export default component.exports